<template>
  <printBase ref="LinkQR034" :title="title" :id="id" :page="page" :width="800">
    <div class="printLinkQR" :slot="page == 1 ? 'content' : `content${page}`">
      <div class="printTitle">商保订单退款单</div>
      <table style="width: 100%" class="printContent" border="1" cellspacing="0">
        <tr height="40">
          <td style="width: 12%"><span>退款创建日期</span></td>
          <td style="width: 20%">
            <span>{{ printInfo.createTime }}</span>
          </td>
          <td colspan="2" style="width: 12%"><span>订单创建日期</span></td>
          <td colspan="3" style="width: 21%">
            <span>{{ printInfo.orderCreateTime }}</span>
          </td>
          <td colspan="2" style="width: 15%"><span>三方订单号</span></td>
          <td style="width: 20%">
            <span>{{ printInfo.onlineOrderCode }}</span>
          </td>
        </tr>
        <tr height="140">
          <td colspan="9">
            <div class="leftTop">
              <span>退款原因：</span>
              <span>{{printInfo.refundReasonName}}</span>
            </div>
          </td>
          <td style="width: 20%">
            <div class="leftTop">
              <span>创建人：{{ printInfo.createUserName }}</span>
            </div>
          </td>
        </tr>
        <div v-for="(item, pageIndex) in printInfoList" :key="pageIndex">
          <tr height="40">
            <td><span>品名</span></td>
            <td>
              <span>{{ item.approvedName }}</span>
            </td>
            <td colspan="3"><span>剂型</span></td>
            <td colspan="3">
              <span>{{ item.dosageFormName }}</span>
            </td>
            <td style="width: 11%"><span>规格</span></td>
            <td>
              <span>{{ item.spec }}</span>
            </td>
          </tr>
          <tr height="40">
            <td><span>批准文号</span></td>
            <td>
              <span>{{ item.approvalCode }}</span>
            </td>
             <td colspan="3"><span>生产企业</span></td>
            <td colspan="9">
              <span>{{ item.producer }}</span>
            </td>
          </tr>
          <tr height="40">
            <td><span>数量</span></td>
            <td>
              <span>{{ item.num }}</span>
            </td>
            <td style="width: 8%"><span>单位</span></td>
            <td colspan="4">
              <span>{{ item.minPkgUnitName }}</span>
            </td>
            <td style="width: 8%"><span>单价</span></td>
            <td colspan="4">
              <span>{{ item.realPrice }}</span>
            </td>
          </tr>
        </div>
        <tr height="40">
            <td><span>退款总金额</span></td>
            <td colspan="9">
              <span>{{ printInfo.refundAmount }}</span>
            </td>
          </tr>
        <tr height="140">
          <td colspan="10" class="alignNone">
            <div class="signOpinion">门店管理员审核意见：</div>
            <br />
            <span class="signContent">同意</span>
            <div class="rightBottom">
              <span class="indentationRight">门店管理员：{{ printInfo.createUserName }}</span>
              <span>{{ printInfo.createTimeBottom }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </printBase>
</template>
<script>
import printBase from './printBase';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-034',
      id: 'LinkQR030',
      printInfo: {},
      printInfoList: [],
      page: 1,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(saleRefundInfo) {
      console.log(saleRefundInfo);
      this.printInfo = {
        createTime: utils.formatTime(new Date(saleRefundInfo.createTime), 'YYYY-MM-DD'),
        createTimeBottom: utils.formatTime(new Date(saleRefundInfo.createTime), 'YYYY 年 MM 月 DD 日'),
        orderCreateTime: utils.formatTime(new Date(saleRefundInfo.orderCreateTime), 'YYYY-MM-DD'),
        createUserName: saleRefundInfo.createUserName,
        onlineOrderCode: saleRefundInfo.onlineOrderCode,
        refundReasonName: saleRefundInfo.refundReasonName,
        refundAmount: saleRefundInfo.refundAmount,
      };
      saleRefundInfo.refundDetailList.forEach((item) => {
        item.expiryDate = utils.formatTime(item.expiryDate, 'YYYY年MM月DD日');
      });
      this.printInfoList = saleRefundInfo.refundDetailList;
      this.$nextTick(() => {
        this.$refs.LinkQR034.handlePrint();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.printContent td,
th {
  text-align: center;
  position: relative;
  border-color: #000;
  font-weight: 300;
  word-break: break-all;
  padding: 2px 6px;
  font-size: 12px;
  * {
    display: inline-block;
    max-height: 50px;
    overflow: hidden;
  }
}
</style>
